import { DeleteOutlined } from "@ant-design/icons";
import Button from "../../../Helpers/Button/Button";
import { formatSize } from "../../../../utils";

const getFileIconUrl = (type = "") => {
  const lowerType = type.toLowerCase();
  if (lowerType === "image/png")
    return `${process.env.PUBLIC_URL}/assets/PNG.svg`;
  if (lowerType === "image/jpg" || lowerType === "image/jpeg")
    return `${process.env.PUBLIC_URL}/assets/JPG.svg`;
  if (lowerType === "application/pdf")
    return `${process.env.PUBLIC_URL}/assets/PDF.svg`;
  return `${process.env.PUBLIC_URL}/assets/Excel.svg`;
};

const UploadedDocuments = ({ document, onDelete }) => {
  const { originalName, mimeType, sizeMB } = document;

  return (
    <div className="d-flex align-items-center justify-content-between border p-2 mb-2 bg-white">
      <div className="d-flex align-items-center">
        <img
          src={getFileIconUrl(mimeType)}
          alt={mimeType}
          style={{ width: 40 }}
          className="me-3"
        />
        <div>
          <div
            className="fw-medium text-truncate"
            style={{ maxWidth: "200px" }}
          >
            {originalName}
          </div>
          <div className="text-muted small">
            {formatSize(sizeMB * 1024 * 1024)}
          </div>
        </div>
      </div>
      <Button
        htmlType="button"
        type="text"
        icon={<DeleteOutlined />}
        className={"remove-skill"}
        danger
        onClick={onDelete}
      />
    </div>
  );
};

export default UploadedDocuments;
